<div class="summary-cards-wrapper">
  <button
    class="summary-scroll-indicator"
    type="button"
    aria-label="Scroll right"
    (click)="scrollRight()"
  >
    <i class="bi bi-chevron-right"></i>
  </button>
  <div class="summary-cards" #scrollWrapper>
    @for (card of cards; track card) {
      <div
        class="card"
        [ngClass]="{
          active: activeCard?.title === card.title,
          'clickable-card': isCardClickable(card)
        }"
        (click)="onCardClick(card)"
      >
        <p class="card-title">{{ card.title }}</p>
        <div class="card-content">
          <i class="bi {{ card.icon }} dashboard-icon"></i>
          <h2>{{ card.value }}</h2>
        </div>
      </div>
    }
  </div>
</div>
